export default function searchResultsReducer(state, action) {
  console.log('----End State Update----', action, state);
  switch (action.type) {
    case 'SET_SORT':
      return {
        ...state,
        sortBy: action.sortBy,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sortBy.js